import { useLang } from "@/context/LanguageContext";
import { SITE_LANGS, Flag } from "@/components/LangFlags";
import ThemeToggle from "@/components/ThemeToggle";

// ---------------------------------------------------------------------------
// Sprache als Pillen (mobile/components/LanguageSwitcher.tsx: aktiv dunkel,
// sonst surface2) und darunter Hell/Dunkel — am Handy im Menü-Sheet der
// Kopfzeile UND unten im Profil, wie in der App. Eine Komponente, damit beide
// Stellen nicht auseinanderlaufen. testids wie im früheren Mobilmenü.
// ---------------------------------------------------------------------------
export default function SpracheUndThema({ themeTestId = "mobile-theme-toggle", langTestId = "mobile-lang" }) {
  const { lang, switchLanguage, t } = useLang();
  return (
    <>
      <div>
        <div className="kicker mb-3">{t("footer.lang_label")}</div>
        <div className="flex flex-wrap gap-2" data-testid={`${langTestId}-switcher`}>
          {SITE_LANGS.map((l) => (
            <button
              key={l.code}
              type="button"
              data-testid={`${langTestId}-${l.code}`}
              aria-pressed={lang === l.code}
              onClick={() => switchLanguage(l.code)}
              className={`inline-flex items-center gap-2 rounded-full px-3.5 py-2 text-[13px] font-medium transition-colors ${lang === l.code ? "bg-inkchip text-white" : "bg-surface2 text-anthracite"}`}
            >
              <Flag code={l.code} /> {l.label}
            </button>
          ))}
        </div>
      </div>
      <div>
        <div className="kicker mb-3">{t("theme.label")}</div>
        <ThemeToggle testId={themeTestId} wide />
      </div>
    </>
  );
}
